import { atom } from "@byko/lib-recoil";

export const blockDrawerClickOutsideState = atom<boolean>({
  key: "block-drawer-click-outside-state",
  default: false,
});
